const SITE_ORIGIN = 'https://miamisoundrental.com'

const item = (name, path) => ({
  name,
  url: `${SITE_ORIGIN}${path === '/' ? '' : path}`
})

const AUDIO_FAMILY_BREADCRUMBS = {
  '/sound-system-rental': [
    item('Home', '/'),
    item('Sound System Rental', '/sound-system-rental')
  ],
  '/speaker-rental': [
    item('Home', '/'),
    item('Sound System Rental', '/sound-system-rental'),
    item('Speaker Rental', '/speaker-rental')
  ],
  '/orlando/speaker-rental': [
    item('Home', '/'),
    item('Orlando AV Rental', '/orlando'),
    item('Speaker Rental', '/orlando/speaker-rental')
  ],
  '/microphone-rental': [
    item('Home', '/'),
    item('Sound System Rental', '/sound-system-rental'),
    item('Microphone Rental', '/microphone-rental')
  ],
  '/karaoke-rental': [
    item('Home', '/'),
    item('Sound System Rental', '/sound-system-rental'),
    item('Karaoke Rental', '/karaoke-rental')
  ],
  '/orlando/karaoke-rental': [
    item('Home', '/'),
    item('Orlando AV Rental', '/orlando'),
    item('Karaoke Machine Rental', '/orlando/karaoke-rental')
  ],
  '/sound/array': [
    item('Home', '/'),
    item('Sound System Rental', '/sound-system-rental'),
    item('Line Array Speaker Rental', '/sound/array')
  ],
  '/sound/microphone-and-speaker': [
    item('Home', '/'),
    item('Sound System Rental', '/sound-system-rental'),
    item('Microphone & Speaker Packages', '/sound/microphone-and-speaker')
  ],
  '/band-equipment/mixers': [
    item('Home', '/'),
    item('Sound System Rental', '/sound-system-rental'),
    item('Live Sound Mixers Rental', '/band-equipment/mixers')
  ],
  '/sound/amplifiers': [
    item('Home', '/'),
    item('Speaker Rental', '/speaker-rental'),
    item('PA Power Amplifier & Amp Rack Rental', '/sound/amplifiers')
  ],
  '/sound/monitors': [
    item('Home', '/'),
    item('Speaker Rental', '/speaker-rental'),
    item('Stage Monitor & In-Ear Monitor Rental', '/sound/monitors')
  ],
  '/sound/recorders': [
    item('Home', '/'),
    item('Speaker Rental', '/speaker-rental'),
    item('Portable Audio & Field Recorder Rental', '/sound/recorders')
  ],
  '/sound/subwoofer': [
    item('Home', '/'),
    item('Speaker Rental', '/speaker-rental'),
    item('Subwoofer Rental', '/sound/subwoofer')
  ]
}

export const getAudioFamilyBreadcrumbs = path => (
  (AUDIO_FAMILY_BREADCRUMBS[path] || []).map(breadcrumb => ({ ...breadcrumb }))
)

export const toHeroBreadcrumbs = breadcrumbs => (breadcrumbs || []).map((breadcrumb, index, list) => ({
  label: breadcrumb.name,
  href: index === list.length - 1
    ? undefined
    : breadcrumb.url.replace(SITE_ORIGIN, '') || '/'
}))

export const toBreadcrumbJsonLdItems = breadcrumbs => (breadcrumbs || []).map((breadcrumb, index) => ({
  position: index + 1,
  name: breadcrumb.name,
  item: breadcrumb.url
}))

export default AUDIO_FAMILY_BREADCRUMBS
